"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromotionPlugin = void 0;
function isPromotionPlugin(value) {
    return value.open !== undefined && value.close !== undefined;
}
exports.isPromotionPlugin = isPromotionPlugin;
//# sourceMappingURL=PromotionPlugin.js.map